import { combineReducers } from 'redux';
import loginReducer from './login.reducer';
import usersReducer from './users.reducer';
import placesReducer from './places.reducer';
import reportedUsersReducer from './reportedUsers.reducer';
import referralsReducer from './referrals.reducer';
import notificationsReducer from './notifications.reducer';
import chatsReducer from './chats.reducer';
import organizationsReducer from './organizations.reducer';
import promocodesReducer from './promocodes.reducer';
import dashboardReducer from './dashboard.reducer';
import activitiesAndEventsReducer from './activitiesAndEvents.reducer';
import paymentReducer from './payments.reducer';
export const rootReducer = combineReducers({
  loginReducer,
  usersReducer,
  placesReducer,
  reportedUsersReducer,
  referralsReducer,
  notificationsReducer,
  chatsReducer,
  organizationsReducer,
  promocodesReducer,
  dashboardReducer,
  activitiesAndEventsReducer,
  paymentReducer,
});
